import type { IRecording } from '@carboncopyco/types';
import { camelCase } from 'camel-case';
import type { CamelCase } from 'type-fest';
import { type TrackEventProperties, useAnalytics } from '../context';
import { TrackEventCloneNames } from '../types';

type EventName = keyof typeof TrackEventCloneNames;
type FunctionName =
  `track${Capitalize<CamelCase<keyof typeof TrackEventCloneNames>>}`;
const functionNameEntries = Object.keys(TrackEventCloneNames).map(
  (eventName) => [
    eventName as EventName,
    `track${eventName[0].toUpperCase()}${camelCase(eventName.slice(1))}` as FunctionName,
  ]
);

export const useCloneAnalytics = ({
  location,
  cloneId,
}: {
  location: string;
  cloneId: IRecording['id'];
}) => {
  const { trackEvent } = useAnalytics();

  return Object.fromEntries(
    functionNameEntries.map(([eventName, functionName]) => [
      functionName,
      (payload?: TrackEventProperties) => {
        trackEvent(TrackEventCloneNames[eventName], {
          ...payload,
          cloneId,
          location,
        });
      },
    ])
  ) as {
    [K in FunctionName]: (payload?: Record<string, any>) => void;
  };
};
